<div  class="form-text-area {{config.class}}">
    <div class="default-sub-header text-label">{{config.label | translate}} <span *ngIf="config.isMandatory" class="mandatory-field">*</span></div>
    <div class="group-elements">
        <mat-form-field class="dropdown" [ngClass]="{'input-with-boundary':config.appearance}">
            <mat-select (selectionChange)="selectedOption($event)" [(value)]="config.value" [disabled]="config.disableSelect">                
                <mat-option *ngFor="let option of config.options" [value]="option.id">{{option.value}}</mat-option>                
            </mat-select>
        </mat-form-field>
        <mat-form-field [formGroup]="group" class="text-field" [ngClass]="{'input-with-boundary':config.appearance}">
            <input matInput placeholder="{{config.placeholder | translate}}" [type]="config.inputType? config.inputType:'text'"
            [maxlength]="this.dfs.requiredPhoneNumberLength$" [formControlName]="config.name" (keyup)="onKeyup($event)"   phoneNumber>

            <mat-error
            *ngIf="group.controls[FormControlName].hasError('required') && config.showErrorText">
            {{config.errorMessage | translate}}
          </mat-error>
         <mat-error *ngIf="(group.controls[FormControlName].hasError('minlength') || group.controls[FormControlName].hasError('maxlength')) && config.showErrorText">
            {{'invalidPhone' | translate}}
          </mat-error>
        </mat-form-field>
    </div>
</div>